import { render, staticRenderFns } from "./HsabBiometricAuthSetup.vue?vue&type=template&id=7073d624&scoped=true"
import script from "./HsabBiometricAuthSetup.vue?vue&type=script&lang=ts"
export * from "./HsabBiometricAuthSetup.vue?vue&type=script&lang=ts"
import style0 from "./HsabBiometricAuthSetup.vue?vue&type=style&index=0&id=7073d624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073d624",
  null
  
)

export default component.exports